import { Product } from './product';

export class ProductPaginData {
    Products?: Product[] | any;
    ProductCount?: any;
}
